import { render } from "./RadioForm.vue?vue&type=template&id=623f1d22"
import script from "./RadioForm.vue?vue&type=script&lang=js"
export * from "./RadioForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__